import loading from './loading/loading'
import scroll from './scroll'

export default { loading, scroll}



// WEBPACK FOOTER //
// ./src/components/index.js